module.exports = __webpack_public_path__ + "static/media/hero3.95002571.png";